module.exports = __webpack_public_path__ + "img/13_Practical Fixer.cc82a82e.svg";